import { AppRoute } from '@launchpad/components';
import BaseModule from '@launchpad/logic/module/BaseModule';
import React from 'react';
import PushDashboard from './PushDashboard';
import AddUserGroup from './user-groups/AddUserGroup';
import UserGroupDetails from './user-groups/UserGroupDetails';
import UserGroupEdit from './user-groups/UserGroupEdit';
import UserGroupsList from './user-groups/UserGroupsList';

export const NAME = 'notifications';

export default class NotificationsModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'notifications.*';
  }

  getPolicy() {
    return 'Admin:Notification:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'Notifications',
        icon: 'bell',
        // path: '/push-notifications',
        permission: 'notifications.*',
        policy: 'Admin:Notification:View:*',
        children: [
          // {
          //   label: 'Push dashboard',
          //   path: '/push-dashboard',
          //   icon: 'dashboard',
          //   permission: 'notifications.dashboard.*',
          //   policy: 'Admin:Notification:View:*',
          // },
          {
            label: 'Send new notification',
            path: '/push-notifications/add-new',
            icon: 'plus',
            permission: 'notifications.send.*',
            policy: 'Admin:Notification:View:*'
          },
          {
            label: 'Sent notifications',
            path: '/push-notifications',
            icon: 'paper-plane',
            permission: 'notifications.sent.*',
            policy: 'Admin:Notification:View:*'
          },
          {
            label: 'User Groups',
            path: '/user-groups',
            icon: 'users',
            permission: 'notifications.groups.*',
            policy: 'Admin:Notification:View:*'
          }
        ]
      }
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      // <AppRoute
      //   path={`${currentUrl}push-dashboard`}
      //   component={PushDashboard}
      // />,
      <AppRoute
        path={`${currentUrl}push-notifications`}
        load={() => import('./PushNotificationsPage')}
      />,
      <AppRoute
        path={`${currentUrl}user-groups/add`}
        component={AddUserGroup}
      />,
      <AppRoute
        path={`${currentUrl}user-groups/details/:id`}
        component={UserGroupDetails}
      />,
      <AppRoute
        path={`${currentUrl}user-groups/edit/:id`}
        component={UserGroupEdit}
      />,
      <AppRoute
        path={`${currentUrl}user-groups`}
        exact
        component={UserGroupsList}
      />
    ];
  }
}
